import { useEffect, useState } from 'react'
import useStepTemplate from 'hooks/useStepTemplate'

const useIdentityDocument = ({ fireboltStep, customGoBack }) => {
  const iframeUrl = sessionStorage.getItem('bb-caf-url') || fireboltStep?.webhookResult?.processedData?.onboarding_url
  const iframeSuccess = sessionStorage.getItem('bb-caf-success')
  const timeToGoToNextStep = 1000
  const [showIframe, setShowIframe] = useState(false)
  const [isGoingToNextStep, setIsGoingToNextStep] = useState(false)

  const { handleGoBackform, runBeforeChangeStep } = useStepTemplate({
    fireboltStep,
    customGoBack,
  })

  function handleButton() {
    setShowIframe(!showIframe)
  }

  function handleSubmit() {
    fireboltStep?.goNextStep({ document_sent: true })
  }

  function checkMessages(event) {
    const isMessageFinishedOnboarding = event?.data?.code === 'ONBOARDING_FINISHED'

    if (isMessageFinishedOnboarding) {
      setIsGoingToNextStep(true)
      sessionStorage.setItem('bb-caf-success', true)
    }
  }

  useEffect(() => {
    if (fireboltStep?.webhookResult?.processedData?.onboarding_url) {
      sessionStorage.setItem('bb-caf-url', fireboltStep?.webhookResult?.processedData?.onboarding_url)
    }
    if (window) {
      window.addEventListener('message', checkMessages, false)
    }
  }, [])

  useEffect(() => {
    if (isGoingToNextStep) {
      setTimeout(() => {
        handleSubmit()
      }, timeToGoToNextStep)
    }
  }, [isGoingToNextStep])

  return {
    handleGoBackform,
    runBeforeChangeStep,
    handleButton,
    handleSubmit,
    showIframe,
    iframeUrl,
    iframeSuccess,
  }
}

export default useIdentityDocument
